export default __webpack_public_path__ + "cbfa51ac077f7e3a990544e729d33184.svg";